import { QueryKey } from '@/application/queryKeys';
import fetchV2Positions from '@/infrastructure/migrate/fetchV2Positions';
import { useNftx } from '@nftx/react';
import { Address, BadRequestError } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';

const useV2Positions = ({
  userAddress,
}: {
  userAddress: Address | undefined;
}) => {
  const { network, provider } = useNftx();

  return useQuery(
    [QueryKey.V2_POSITIONS, network, userAddress],
    () => {
      if (!userAddress) {
        throw new BadRequestError('No user address provided');
      }
      return fetchV2Positions({ network, userAddress, provider });
    },
    { enabled: !!userAddress, staleTime: 60000, refetchInterval: 60000 }
  );
};

export default useV2Positions;
